import React from "react";
import {Grid, Typography, withStyles} from '@material-ui/core'

const useStyles = theme => ({
    contentTxt: {
        color: "#4f4f4f",
        fontSize: '14px',
        marginTop: '0.7em',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    },
    labelTxt: {
        color: "#4f4f4f",
        fontSize: '14px',
        marginTop: '0.7em',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    },
    footerCopyright: {
        color: "#4f4f4f",
        marginTop: "2.2em",
        fontSize: '14px',
        flexBasis: '100% !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    },
})

class FooterInfo extends React.Component {
    render() {
        const {classes, label, content, isCopyRight} = this.props;
        return (
            <Grid container>
                <Grid item xs={5} style={{paddingRight: '16px'}}>
                    <Typography
                        variant="subtitle1"
                        color="textSecondary"
                        className={classes.labelTxt}
                    >
                        {label}
                    </Typography>
                </Grid>
                <Grid item xs={7}>
                    <Typography
                        variant="subtitle1"
                        className={isCopyRight ? classes.footerCopyright : classes.contentTxt}
                    >
                        {content}
                    </Typography>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(useStyles)(FooterInfo)
